// extracted by mini-css-extract-plugin
export var base = "_33-0";
export var updateBanner = "_33-1";